/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import { useMemo, useState } from "react";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import _ from "lodash";
import moment from "moment";
import "moment/locale/es"; // Importa el locale en español
import { saveAs } from "file-saver";
import { MaterialReactTable, MRT_ActionMenuItem } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import DescargarArchivo from "../DescargaArchivos";
import MDTypography from "components/MDTypography";
import Icon from "@mui/material/Icon";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
//nested data is ok, see accessorKeys in ColumnDef below
import MDBox from "components/MDBox";
import { Badge, Grid } from "@mui/material";
import { decargarExcelSolicitudes } from "store/download/dowloadActions";
import {
  getNotificacionesXsolicitud,
  obtenerSolicitudExcel,
  getInformacionInicialDocumentosExcel,
} from "store/solicitudes/solicitudesActions";
import { InformacionCitasExcel } from "store/tav/tavActions";
import { useDispatch, useSelector } from "react-redux";
import Loading from "components/loading";
import { store } from "store/store";
import { generarExcelDetalle } from "./GeneradorExcelSolicitud";
import toast from "react-hot-toast";

const Example = ({ columns, data, showModal, VerSolicitud, esSolicitud, EliminarSolicitud }) => {
  const { progress, loading } = useSelector((state) => state.download);
  const { catalogos } = useSelector((state) => state.solicitud);
  const dispatch = useDispatch();
  //should be memoized or stable

  const exportarExcel = async () => {
    const ids = _.map(data, "idSolicitud");
    const response = await dispatch(decargarExcelSolicitudes(ids));
    const datos = [];
    _.map(response, (item) => {
      datos.push({
        idSolicitud: item.idSolicitud,
        personaBeneficiaria: item.personaBeneficiaria,
        sexo: item.sexo,
        fechaNacimiento: item.fechaNacimiento,
        edadEnLaQueAplico: item.edadEnLaQueAplico,
        tipoHipoacusia: item.tipoHipoacusia,
        servicioMedicoInfante: item.servicioMedicoInfante,
        estado: item.estado,
        municipio: item.municipio,
        localidad: item.localidad,
        nombrePadre: item.nombrePadre,
        ocupacionPadre: item.ocupacionPadre,
        nombreMadre: item.nombreMadre,
        ocupacionMadre: item.ocupacionMadre,
        cuidadorPrimario: item.cuidadorPrimario,
      });
    });

    // 1️⃣ Crear workbook y hoja
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Solicitudes");

    // 2️⃣ Definir columnas con encabezados, claves y anchos
    worksheet.columns = [
      { header: "ID", key: "idSolicitud", width: 10 },
      { header: "Persona beneficiaria", key: "personaBeneficiaria", width: 25 },
      { header: "Sexo", key: "sexo", width: 12 },
      { header: "Fecha de nacimiento", key: "fechaNacimiento", width: 20 },
      { header: "Edad en la que aplicó", key: "edadEnLaQueAplico", width: 22 },
      { header: "Tipo de hipoacusia (Tipo de Pérdida)", key: "tipoHipoacusia", width: 30 },
      { header: "Servicio médico del infante", key: "servicioMedicoInfante", width: 30 },
      { header: "Estado", key: "estado", width: 15 },
      { header: "Municipio", key: "municipio", width: 20 },
      { header: "Localidad", key: "localidad", width: 20 },
      { header: "Nombre del padre", key: "nombrePadre", width: 20 },
      { header: "Ocupación del padre", key: "ocupacionPadre", width: 20 },
      { header: "Nombre de la madre", key: "nombreMadre", width: 20 },
      { header: "Ocupación de la madre", key: "ocupacionMadre", width: 20 },
      { header: "Cuidador", key: "cuidadorPrimario", width: 20 },
    ];

    // 3️⃣ Agregar los datos
    datos.forEach((item) => worksheet.addRow(item));

    // 4️⃣ Aplicar estilo a la primera fila (encabezados)
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF605CA9" }, // morado oscuro
      };
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };
    });

    // 5️⃣ Generar y descargar
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const nombreArchivo = `${esSolicitud ? "Solicitudes" : "Expedientes"}_${moment().format(
      "YYYY-MM-DD_HH-mm-ss"
    )}.xlsx`;
    saveAs(blob, nombreArchivo);
  };

  const exportarExcelIndividual = async (idSolicitud) => {
    let id = toast.loading("Procesando datos, por favor espere...");
    // Llamadas necesarias
    const detalleSolicitud = await obtenerSolicitudExcel(idSolicitud);
    const documentos = await getInformacionInicialDocumentosExcel(idSolicitud);

    const documentacionAdministrativa = [
      {
        label: "Carta de Inicio",
        archivo: detalleSolicitud.archivoCartaInicio,
        validado: detalleSolicitud.docCartaInicioValidada,
        validadopor: detalleSolicitud.docCartaInicioValidadaPorName,
      },
      {
        label: "Cuestionario de Expectativas",
        archivo: detalleSolicitud.archivoCuestionarioExpectativas,
        validado: detalleSolicitud.docCuestionarioValidado,
        validadopor: detalleSolicitud.docCuestionarioValidadoPorName,
      },
      {
        label: "Acta de nacimiento del menor",
        archivo: detalleSolicitud.archivoActaNacimiento,
        validado: detalleSolicitud.docActaNacimValidada,
        validadopor: detalleSolicitud.docActaNacimValidadaPorName,
      },
      {
        label: "CURP del Menor",
        archivo: detalleSolicitud.archivoCurpMenor,
        validado: detalleSolicitud.docCurpMenorValidada,
        validadopor: detalleSolicitud.docCurpMenorValidadaPorName,
      },
      {
        label: "CURP del Padre",
        archivo: detalleSolicitud.archivoCurpPadre,
        validado: detalleSolicitud.docCurpPadreValidada,
        validadopor: detalleSolicitud.docCurpPadreValidadaPorName,
      },
      {
        label: "CURP de la Madre",
        archivo: detalleSolicitud.archivoCurpMadre,
        validado: detalleSolicitud.docCurpMadreValidada,
        validadopor: detalleSolicitud.docCurpMadreValidadaPorName,
      },
      {
        label: "Identificación oficial del Padre",
        archivo: detalleSolicitud.archivoIdentificacionPadre,
        validado: detalleSolicitud.docIdentificaPadreValidada,
        validadopor: detalleSolicitud.docIdentificaPadreValidadaPorName,
      },
      {
        label: "Identificación oficial de la Madre",
        archivo: detalleSolicitud.archivoIdentificacionMadre,
        validado: detalleSolicitud.docIdentificaMadreValidada,
        validadopor: detalleSolicitud.docIdentificaMadreValidadaPorName,
      },
      {
        label: "Cartilla de Vacunación",
        archivo: detalleSolicitud.archivoCartillaVacunacion,
        validado: detalleSolicitud.docCartillaVacunaValidada,
        validadopor: detalleSolicitud.docCartillaVacunaValidadaPorName,
      },
      {
        label: "Comprobante de Domicilio",
        archivo: detalleSolicitud.archivoComprobanteDomicilio,
        validado: detalleSolicitud.docComprobanteDomValidada,
        validadopor: detalleSolicitud.docComprobanteDomValidadaPorName,
      },
      {
        label: "Carta de Aceptación",
        archivo: detalleSolicitud.archivoCartaAceptacion,
        validado: detalleSolicitud.docCartaAceptacionValidada,
        validadopor: detalleSolicitud.docCartaAceptacionValidadaPorName,
      },
      {
        label: "Carta de Autorización Uso de Imagen Papá",
        archivo: detalleSolicitud.archivoCartaImagenPapa,
        validado: detalleSolicitud.docCartaAutorizacionImagenPapaValidada,
        validadopor: detalleSolicitud.docCartaAutorizacionImagenPapaValidadaPorName,
      },
      {
        label: "Carta de Autorización Uso de Imagen Mamá",
        archivo: detalleSolicitud.archivoCartaImagenMama,
        validado: detalleSolicitud.docCartaAutorizacionImagenMamaValidada,
        validadopor: detalleSolicitud.docCartaAutorizacionImagenMamaValidadaPorName,
      },
      {
        label: "Carta de Autorización Uso de Imagen Candidato",
        archivo: detalleSolicitud.archivoCartaImagenCandidato,
        validado: detalleSolicitud.docCartaAutorizacionImagenCandidatoValidada,
        validadopor: detalleSolicitud.docCartaAutorizacionImagenCandidatoValidadaPorName,
      },
      {
        label: "Carta transferencia de Datos",
        archivo: detalleSolicitud.archivoCartaTransferenciaDatos,
        validado: detalleSolicitud.docCartaTransferenciaValidado,
        validadopor: detalleSolicitud.validaTransferenciaDatos,
      },
    ];

    const citas = await InformacionCitasExcel(idSolicitud);
    moment.locale("es");

    const ahora = moment();
    const citasAnteriores = citas.filter((cita) =>
      moment(cita.fechaCita)
        .set({
          hour: cita.horaCita,
          minute: cita.minutoCita,
          second: 0,
          millisecond: 0,
        })
        .isBefore(ahora)
    );

    const citasProximas = citas.filter((cita) =>
      moment(cita.fechaCita)
        .set({
          hour: cita.horaCita,
          minute: cita.minutoCita,
          second: 0,
          millisecond: 0,
        })
        .isSameOrAfter(ahora)
    );

    const notificaciones = await getInformacionInicialDocumentosExcel(idSolicitud);

    // Luego, generar el Excel
    try {
      await generarExcelDetalle(
        detalleSolicitud,
        documentacionAdministrativa,
        documentos,
        catalogos,
        citasAnteriores,
        citasProximas,
        esSolicitud
      );
    } catch (error) {
      toast.error("Error al procesaro los datos.");
    }
    toast.remove(id);
  };

  const usuarioPermisos = store.getState().login?.usuario?.permisos;
  const eliminarSolicitudExpediente = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (esSolicitud ? 46 : 87)
  );
  const descargarSolicitudExpediente = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (esSolicitud ? 52 : 88)
  );

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      localization={MRT_Localization_ES}
      autoResetPageIndex={false}
      initialState={{
        density: "compact",
        columnPinning: {
          left: ["mrt-row-expand", "mrt-row-select"],
          right: ["mrt-row-actions"],
        },
      }}
      paginationDisplayMode="pages"
      muiPaginationProps={{
        sx: {
          // Estilo general del componente de paginación
          "& .MuiPaginationItem-root": {
            color: "#FFFFFF", // Color de todos los números de página
          },
          "& .Mui-selected": {
            fontWeight: "bold",
            color: "#F58020", // Color del texto seleccionado
          },
        },
      }}
      muiTableHeadProps={{
        sx: { display: "table-header-group" },
      }}
      muiTableBodyCellProps={({ row, cell }) => {
        return {
          sx: {
            color:
              cell.column.id === "precandidato"
                ? row.original.leido
                  ? "#FFFFFF"
                  : "#F58020"
                : "#FFFFFF",
            opacity: cell.column.id === "precandidato" ? (row.original.leido ? "0.7" : "1") : "0.7",
            fontWeight:
              cell.column.id === "precandidato"
                ? row.original.leido
                  ? "normal"
                  : "bold"
                : "normal",
            fontSize: 12,
          },
        };
      }}
      muiTableHeadCellProps={{
        sx: { color: "#FFFFFF", fontSize: 12 },
      }}
      icons={{
        SearchIcon: () => <Icon color="primary">search</Icon>,
        SearchOffIcon: () => <Icon color="primary">search_off</Icon>,
        CloseIcon: () => <Icon color="primary">close</Icon>,
        FullscreenIcon: () => <Icon color="primary">fullscreen</Icon>,
        FullscreenExitIcon: () => <Icon color="primary">fullscreen_exit</Icon>,
        FilterAltIcon: () => <Icon color="primary">search</Icon>,
        FilterListIcon: () => <Icon color="primary">filter_list</Icon>,
        FilterListOffIcon: () => <Icon color="primary">filter_list_off</Icon>,
        DensitySmallIcon: () => <Icon color="primary">density_small</Icon>,
        DensityMediumIcon: () => <Icon color="primary">density_medium</Icon>,
        DensityLargeIcon: () => <Icon color="primary">density_large</Icon>,
        FirstPageIcon: () => <Icon color="primary">first_page</Icon>,
        LastPageIcon: () => <Icon color="primary">last_page</Icon>,
        ChevronLeftIcon: () => <Icon color="primary">navigate_before</Icon>,
        ChevronRightIcon: () => <Icon color="primary">navigate_next</Icon>,
        MoreVertIcon: () => <Icon color="primary">more_vert</Icon>,
        MoreHorizIcon: () => <Icon color="primary">more_horiz</Icon>,
        SortIcon: () => <Icon color="primary">sort</Icon>,
        ClearAllIcon: () => <Icon color="primary">clear_all</Icon>,
        VisibilityOffIcon: () => <Icon color="primary">visibility_off</Icon>,
        ViewColumnIcon: () => <Icon color="primary">view_column</Icon>,
        SyncAltIcon: () => <Icon color="primary">import_export</Icon>,
        ArrowDownwardIcon: (props) => {
          var icon = <Icon color="primary">arrow_downward</Icon>;
          props.className ===
          "MuiTableSortLabel-icon MuiTableSortLabel-iconDirectionAsc css-1hi7cb7-MuiTableSortLabel-icon"
            ? (icon = <Icon color="primary">arrow_upward</Icon>)
            : (icon = <Icon color="primary">arrow_downward</Icon>);

          return icon;
        },
        ArrowRightIcon: () => <Icon color="primary">import_export</Icon>,
        ArrowDownwardIcon: () => <Icon color="primary">import_export</Icon>,
      }}
      enableExpanding={true}
      renderDetailPanel={({ row }) => {
        //getNotificacionesXsolicitud(dispatch,row.original?.idSolicitud );
        return (
          <Box>
            {row.original?.loading ? (
              <Loading title="Cargandooo" />
            ) : (
              <Box>
                {Array.isArray(row.original?.notificaciones) &&
                row.original?.notificaciones?.length == 0 ? (
                  <MDBox textAlign="center">
                    <MDTypography variant="text" color="warning" fontSize="12px">
                      Sin resultados
                    </MDTypography>
                  </MDBox>
                ) : (
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6} lg={6}>
                      <MDTypography variant="text" color="warning" fontSize="12px">
                        Mensaje
                      </MDTypography>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                      <MDTypography variant="text" color="warning" fontSize="12px">
                        Fecha
                      </MDTypography>
                    </Grid>
                  </Grid>
                )}
                {_.map(row.original?.notificaciones, (item) => {
                  return (
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6} lg={6}>
                        <MDTypography variant="text" color="white" fontSize="12px">
                          {item.mensaje}
                        </MDTypography>
                      </Grid>
                      <Grid item xs={12} md={6} lg={6}>
                        <MDTypography variant="text" color="white" fontSize="12px">
                          {moment.utc(item.fechaNotificacion).isAfter(moment("2025-09-04"))
                            ? moment
                                .utc(item.fechaNotificacion)
                                .tz("America/Mexico_City")
                                .format("DD/MM/YYYY HH:mm:ss")
                            : moment.utc(item.fechaNotificacion).format("DD/MM/YYYY HH:mm:ss")}
                        </MDTypography>
                      </Grid>
                    </Grid>
                  );
                })}
              </Box>
            )}
          </Box>
        );
      }}
      muiExpandButtonProps={({ row, table }) => ({
        children: row.getIsExpanded() ? (
          <Icon sx={{ background: "#5873B8", borderRadius: "50%" }}>circle_notifications</Icon>
        ) : (
          <Badge
            color={row.original?.tieneNotificacionesPendientes ? "error" : "secondary"}
            variant="dot"
          >
            <Icon
              sx={{ background: "#5873B8", borderRadius: "50%" }}
              onClick={() => {
                dispatch(getNotificacionesXsolicitud(row.original?.idSolicitud));
              }}
            >
              circle_notifications
            </Icon>
          </Badge>
        ),
      })}
      enableRowActions={true}
      renderRowActionMenuItems={({ row, table, closeMenu }) => {
        var opciones = [];
        opciones.push(
          <MRT_ActionMenuItem
            icon={<Icon color="success">preview</Icon>}
            key="ver"
            label={"Ver ".concat(!esSolicitud ? "Expediente" : "Solicitud")}
            onClick={() => {
              VerSolicitud(row.original, esSolicitud, data.length - row.index);
              closeMenu();
            }}
            table={table}
          />
        );
        if (eliminarSolicitudExpediente.length > 0) {
          opciones.push(
            <MRT_ActionMenuItem //or just use a normal MUI MenuItem component
              icon={<Icon color="error">delete</Icon>}
              key="edit"
              label={"Eliminar ".concat(!esSolicitud ? "Expediente" : "Solicitud")}
              onClick={() => {
                EliminarSolicitud(row.original);
                closeMenu();
              }}
              table={table}
            />
          );
        }
        if (descargarSolicitudExpediente.length > 0) {
          opciones.push(
            <MRT_ActionMenuItem
              icon={<Icon color="warning">picture_as_pdf</Icon>}
              key="delete"
              label={"Decargar ".concat(!esSolicitud ? "Expediente" : "Solicitud")}
              onClick={() => {
                exportarExcelIndividual(row.original.idSolicitud);
                closeMenu();
              }}
              table={table}
            />
          );
        }
        return opciones;
      }}
      renderTopToolbarCustomActions={({ table }) => {
        return (
          <Box
            sx={{
              display: "flex",
              gap: "16px",
              padding: "8px",
              flexWrap: "wrap",
            }}
          >
            {esSolicitud && (
              <Button
                variant="contained"
                startIcon={<Icon>add</Icon>}
                color="primary"
                size="small"
                style={{ textTransform: "inherit", background: "#605CA9" }}
                onClick={() => {
                  showModal();
                }}
              >
                Nueva solicitud
              </Button>
            )}
            {loading ? (
              <DescargarArchivo progress={progress} />
            ) : descargarSolicitudExpediente.length > 0 ? (
              <Button
                variant="contained"
                startIcon={<Icon size="md">folder_zip</Icon>}
                color="primary"
                size="small"
                style={{ textTransform: "inherit", background: "#605CA9" }}
                onClick={exportarExcel}
              >
                Exportar
              </Button>
            ) : null}
          </Box>
        );
      }}
      muiTableBodyRowProps={({ row }) => ({
        onDoubleClick: () => VerSolicitud(row.original, esSolicitud, data.length - row.index),
        style: { cursor: "pointer" },
      })}
    />
  );
};

export default Example;
